import React from 'react';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { GlobalEventListenerRoot } from 'ui-components/components/global-event-listener/root';

import style from '../common.module.less';

export const FormNumberComparison = (criterionStateMethods, criterionOperatorOptions) => {
  const { getCriterionOperator, getCriterionArgument, updateCriterionOperator, updateCriterionArgument } = criterionStateMethods;
  const selectedComparator = getCriterionOperator();
  const selectedComparatorLabel = selectedComparator ? selectedComparator.displayName : '';
  const selectedArgument = getCriterionArgument();
  const argumentValue = selectedArgument ? selectedArgument.value : [];
  const argumentValueArray = Array.isArray(argumentValue) ? argumentValue : [argumentValue];

  const onChange = (e) => {
    const value = e.target.value.split(';');
    updateCriterionArgument({
      value: value.reduce((values, current) => {
        const val = parseFloat(current, 10);
        if (Number.isNaN(val)) {
          return values;
        }
        return [...values, val];
      }, []),
    });
  };

  return (
    <div className={style['form-criteria-section']}>
      <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler>{selectedComparatorLabel}</DropdownMenuToggler>
        {criterionOperatorOptions.map((option, index) => (
          <DropdownMenuItem
            key={index}
            onClick={() => updateCriterionOperator(option)}
            selected={option.displayName === selectedComparatorLabel}
          >
            {option.displayName}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
      <GlobalEventListenerRoot>
        <input className={style['number-text-input']} defaultValue={argumentValueArray.join(';')} onChange={onChange} />
      </GlobalEventListenerRoot>
    </div>
  );
};
